/**
 * 问候称呼(1005 上线前收尾)。
 *
 * 生产实测:渠道开的租户没填联系人,登录返回的 displayName 回落成了邮箱 →
 * 首页大字「t1791206291@oem-test.invalid,今天想拿下什么结果?」。
 * 回落顺序:联系人姓名/显示名 → 企业名 → 空(调用方出「您好」)。
 * 任何一档长得像邮箱 / 手机号 / 登录账号 / 租户编码,都跳过不叫。
 */
const EMAIL_RE = /@|\.invalid$/i;
const PHONE_RE = /^\+?\d[\d\s-]{6,}$/;
const TENANT_CODE_RE = /^T-[0-9A-Z]{4,}$/i;

export function isPresentableName(
  raw: string | null | undefined,
  opts: { username?: string | null; tenantCode?: string | null } = {}
): boolean {
  const v = (raw ?? "").trim();
  if (!v) return false;
  if (EMAIL_RE.test(v)) return false;
  if (PHONE_RE.test(v)) return false;
  if (TENANT_CODE_RE.test(v)) return false;
  if (opts.username && v === opts.username.trim()) return false;
  if (opts.tenantCode && v === opts.tenantCode.trim()) return false;
  return true;
}

export interface GreetingSource {
  name?: string | null;
  username?: string | null;
  tenantName?: string | null;
  tenantCode?: string | null;
}

/** 返回可直接放进问候语的称呼;都不合适时返回空串(调用方用「您好」那句)。 */
export function greetingName(u: GreetingSource | null | undefined): string {
  if (!u) return "";
  const opts = { username: u.username, tenantCode: u.tenantCode };
  for (const c of [u.name, u.tenantName]) {
    if (isPresentableName(c, opts)) return c!.trim();
  }
  return "";
}
